import {
  Routes,
  Route,
  Navigate,
  useSearchParams,
  useNavigate,
  useLocation,
} from 'react-router-dom';
import {
  LoginSignupScreen,
  RetrainAgentScreen,
  SignupHomeScreen,
  SignupLaunchScreen,
  SignupOnboardingScreen,
  WabaSetupScreen,
} from '../screens';
import { usePreviousPath } from './use-previous-path';
import { SIGNUP_ONBOARDING, SIGNUP_ROUTES } from '@zonofi/gandalf-utilities';
import React from 'react';
import {
  getIsAuthenticated,
  useAppSelector,
  onAuthSuccess,
  authenticate,
  dispatch,
  finService,
  TrackEventType,
} from '@zonofi/seller-rtk-store';
import { ViewSampleFileScreen } from '../screens/view-sample-file-screen/view-sample-file-screen';

export const AppNavigator = () => {
  const isAuthenticated = useAppSelector(getIsAuthenticated);
  const [searchParams] = useSearchParams();
  const encodedAuthData = searchParams.get('data');
  const navigate = useNavigate();
  const location = useLocation();
  const previousPath = usePreviousPath();

  React.useEffect(() => {
    if (encodedAuthData) {
      const decodedString = atob(encodedAuthData);
      const parsedData = JSON.parse(decodedString);

      dispatch(onAuthSuccess(parsedData));
      dispatch(authenticate());
      if (location.pathname === '/' || location.pathname === '/get-started') {
        navigate(SIGNUP_ONBOARDING.TEST_AGENT.path, { replace: true });
      }
    }
  }, [encodedAuthData]);

  React.useEffect(() => {
    if (
      isAuthenticated &&
      location.pathname === SIGNUP_ONBOARDING.TEST_AGENT.path &&
      previousPath !== SIGNUP_ONBOARDING.TEST_AGENT.path
    ) {
      finService.trackEvent(TrackEventType.SIGNUP_ONBOARDING_STARTED);
    }
  }, [isAuthenticated, location.pathname]);

  return (
    <div className="app-container">
      {isAuthenticated ? (
        <Routes>
          <Route
            path={SIGNUP_ONBOARDING.TEST_AGENT.path}
            element={<SignupOnboardingScreen />}
          />
          <Route
            path={SIGNUP_ONBOARDING.RETRAIN_AGENT.path}
            element={<RetrainAgentScreen />}
          />
          <Route
            path={SIGNUP_ONBOARDING.VIEW_SAMPLE_FILE.path}
            element={<ViewSampleFileScreen />}
          />
          <Route
            path={SIGNUP_ONBOARDING.SIGNUP_LAUNCH.path}
            element={<SignupLaunchScreen />}
          />
          <Route
            path={SIGNUP_ONBOARDING.SIGNUP_HOME.path}
            element={<SignupHomeScreen />}
          />
          {/* <Route path={AGENT_SETUP_ROUTE.path} element={<AgentSetupScreen />} /> */}
          <Route
            path="/facebook-redirect-handler"
            element={<WabaSetupScreen />}
          />
          <Route
            path="/"
            element={
              <Navigate to={SIGNUP_ONBOARDING.TEST_AGENT.path} replace />
            }
          />
          <Route
            path="*"
            element={
              <Navigate to={SIGNUP_ONBOARDING.TEST_AGENT.path} replace />
            }
          />
        </Routes>
      ) : (
        <Routes>
          {Object.values(SIGNUP_ROUTES).map((route) => (
            <Route path={route.path} element={<LoginSignupScreen />} />
          ))}
          <Route
            path="/facebook-redirect-handler"
            element={<WabaSetupScreen />}
          />
          <Route path="/get-started" element={<LoginSignupScreen />} />
          <Route path="/" element={<Navigate to="/get-started" replace />} />
          <Route path="*" element={<Navigate to="/get-started" replace />} />
        </Routes>
      )}
      {/* <JTBDTourController /> */}
    </div>
  );
};
